export default __webpack_public_path__ + "static/streifen_rechts-0a7c4543c2929b964193eeb4c2098d14.gif";